<script>
import BaseInput from '@/components/BaseInput.vue';

export default {
  name: 'DecorCategorySelector',
  components: { BaseInput },
  model: { prop: 'value', event: 'select' },
  props: {
    items: Array,
    value: String,
  },
  data() {
    return {
      filter: '',
    };
  },
  computed: {
    path() {
      const path = [];
      let currId = this.value;

      while (currId) {
        // eslint-disable-next-line no-loop-func
        const currItem = (this.items ?? []).find(i => i['@id'] === currId);
        path.push(currItem);
        currId = currItem.parent;
      }

      return path;
    },
    children() {
      const parentId = this.value ?? null;
      return (this.items ?? []).filter(i => (i.parent ?? null) === parentId);
    },
  },
  methods: {
    select(item) {
      console.log(item['@id']);
      this.$emit('select', item['@id']);
    },
    remove(item) {
      const i = this.path.indexOf(item);
      const newPath = this.path.slice(i + 1);
      const newId = newPath[0]?.['@id'] ?? null;
      this.$emit('select', newId);
    },
  },
};
</script>

<template lang="pug">
.decor-category-selector
  .path(v-if="path.length")
    Btn.path-item(v-for="item in path" :key="item['@id']" @click="remove(item)") {{ item.name }}
      Icon(name="cross" pointer)
  .items
    .item(
      v-for="item in children"
      :key="item['@id']"
      @click="select(item)"
      :style="`background-color: ${ item.color ? item.color : '#F8F7F3' }`"
    ) {{ item.name }}
      img(v-if="item.avatar" :src="item.avatar.url")
      Icon(v-else name="no-image")
</template>

<style scoped lang="scss">
//.title {
//  font-size: 12px;
//  font-weight: 400;
//  line-height: 24px;
//  text-align: left;
//  color: #788CA1;
//  margin-bottom: 20px;
//}

.path {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  gap: 20px;
  margin-bottom: 25px;
}

.path-item {
  display: flex;
  font-weight: 100;
}
.items {
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

.item {
  cursor: pointer;
  border-radius: 8px;
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  font-weight: 500;
  line-height: 19px;
  color: #1E3147;
  padding: 20px;
  min-width: 0;
  text-align: center;
}
</style>
